module.exports = __webpack_public_path__ + "static/media/Swift.340e678c.jpg";